export default "__VITE_ASSET__DZQJiLAI__"